import './styles.css';
import { configureGuildHomeImages } from '../constants/guildHome';
import manifest from './manifest.json';
import { createCatalog, mergeResources } from './catalog';
import de from './common/de.json';
import en from './common/en.json';

const modules = import.meta.glob('./*/package.js', { eager: true, import: 'default' });
const packages = Object.fromEntries(Object.entries(modules).map(([file, pack]) => [file.split('/')[1], pack]));
export const catalog = createCatalog(manifest, packages);
export const commonMessages = { de, en };
const listeners = new Set();
function initialPreference() {
  try {
    const user = JSON.parse(localStorage.getItem('goodvale_user') || 'null');
    const owner = localStorage.getItem('goodvale_token') && user?.userId;
    const cached = JSON.parse(localStorage.getItem(owner ? `goodvale_presentation_account:${owner}` : 'goodvale_presentation_guest') || 'null');
    return cached?.preference || (owner ? user?.presentationMode : null);
  } catch { return null; }
}
let mode = catalog.resolve(initialPreference());
export function getPresentationMode() { return mode; }
export function getPresentation() { return catalog.package(mode); }
export function subscribePresentation(listener) { listeners.add(listener); return () => listeners.delete(listener); }
export function messagesFor(id, language) {
  const neutral = mergeResources(commonMessages[language], catalog.package(catalog.fallback).messages[language]);
  return mergeResources(neutral, catalog.package(id).messages[language]);
}
export function applyPresentation(id) {
  const next = catalog.resolve(id);
  const changed = next !== mode;
  mode = next;
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.presentation = mode;
    document.documentElement.dataset.ornamentation = getPresentation().ornamentation || 'minimal';
  }
  if (changed) listeners.forEach(listener => listener());
}
applyPresentation(mode);
export function presentationIcon(kind, key) { return getPresentation().icon(kind, String(key || '').toUpperCase()); }
export function presentationScene(key, theme) { return getPresentation().scene(String(key || 'SCOUT').toUpperCase(), theme); }
export function presentationGuildImage(theme, room, thumbnail) { return getPresentation().guildImage(theme, room, thumbnail); }

configureGuildHomeImages((...args) => getPresentation().guildImage(...args));
